import { createTheme } from '@mui/material/styles';
import Colors from 'constants/colors';

const COLOUR = {
    BLUE: '#39f',
    DARK_GRAY: '#38424a',
    SLATE: '#3a4249',
    WHITE: '#fff'
};

const TEXT = {
    fontWeight: 500,
    letterSpacing: '0.1px',
    color: Colors.BLACK_87_OPAQUE,
    fontSize: '14px',
};

const themeOptions = {
    typography: {
        fontFamily: 'Open Sans, Helvetica Neue, Arial, Helvetica, sans-serif',
        fontSize: '14px',
        text1: TEXT,
        text2: {
            ...TEXT,
            fontSize: '16px',
        },
        text3: {
            ...TEXT,
            fontSize: '18px',
        },
        text4: {
            ...TEXT,
            fontSize: '20px',
            lineHeight: '32px',
        },
        text5: {
            ...TEXT,
            fontSize: '22px',
            lineHeight: '32px',
        },
        subtitle1: {
            fontSize: '12px',
            color: Colors.TEXT_PRIMARY,
        },
        subtitle2: {
            fontSize: '13px',
            color: Colors.TEXT_PRIMARY,
        },
        textError2: {
            fontSize: '12px',
            color: Colors.ERROR.TEXT,
        },
        caption: {
            fontSize: '11px',
        },
        fontWeight600: {
            fontWeight: 600,
        },
    },
    palette: {
        primary: {
            light: '#dedede',
            main: COLOUR.BLUE,
            dark: '#005fbe',
            contrastText: '#fff'
        },
        secondary: {
            main: '#4c707e',
            contrastText: '#fff'
        },
        tertiary: {
            main: COLOUR.DARK_GRAY,
            light: '#949494',
            title: '#888b8e',
            contrastText: Colors.WHITE,
        },
    },
    components: {
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '4px',
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderRadius: '4px',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#3399ff', // set hover border color
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiSnackbar: {
            styleOverrides: {
                anchorOriginBottomRight: ({theme}) => ({
                    [theme.breakpoints.up('sm')]: {
                        bottom: '100px',
                        right: '45px'
                    }
                })
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginTop: '4px',
                    color: '#a2a2a2',
                    '&.Mui-error': {
                        marginLeft: '1px',
                        color: '#f65c5d',
                        fontSize: 12
                    }
                }
            }
        },
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    marginBottom: '30px'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                arrow: {
                    color: COLOUR.DARK_GRAY,
                },
                tooltip: {
                    backgroundColor: COLOUR.DARK_GRAY,
                    fontSize: 12,
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    textDecoration: 'none',
                },
            },
        },
    }
};

const appTheme = createTheme(themeOptions);

export default {
    appTheme,
};